import { z } from "zod";

export default class SchemaUtils {
  public static readonly idSchema = z.coerce.number().positive().int();
}
